import { SVGProps, Ref, forwardRef } from 'react';

export const MegaphoneFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m10.2 16.87-1.289-.107.874 2.07c.907 2.147 1.36 3.221.969 4.035l-.064.12q-.101.18-.239.336l-.119.119C9.703 24 8.542 24 6.356 24l-.982-.006c-.788-.017-1.288-.08-1.672-.316l-.101-.068a2 2 0 0 1-.16-.131l-.144-.146c-.329-.369-.45-.877-.548-1.731l-.098-.977-.422-4.528c-.416-.102-.746-.238-1.026-.438l-.117-.09q-.235-.196-.427-.433l-.12-.162c-.405-.58-.505-1.325-.53-2.562L0 11c0-2 0-3.062.444-3.824l.095-.148q.175-.25.396-.461l.15-.135c.545-.45 1.279-.613 2.509-.741L5 5.565l5.2-.436z"
                fill="currentColor"
            />
            <path
                d="M12 4.979c2.009-1.224 8.965-6.43 10.917-4.588C23.999 1.413 24 3.75 24 8.419v5.164l-.002 1.644c-.015 3.589-.133 5.49-1.081 6.384l-.095.08c-1.944 1.499-8.016-2.857-10.397-4.4L12 17.02z"
                fill="currentColor"
            />
        </g>
    </svg>
));
MegaphoneFilledSize24Glyph.displayName = 'MegaphoneFilledSize24Glyph';
